<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-card>
      <v-html-field v-model="text" :heightEditor="calcHeightEditor()"></v-html-field>
    </v-card>
    <template #actions>
      <v-btn :disabled="readonly" @click="save">Сохранить</v-btn>
    </template>
</v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import vBtnForm from '../common/BtnForm'
  import vHtmlField from '../common/HtmlField'

  export default {
    name: 'editor-form',
    components: {vBtnForm, vHtmlField},
    data: () => ({
      text: null
    }),
    props: {
      value: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Редактор HTML'
      },
      readonly: {
        type: Boolean,
        default: true
      }
    },
    created () {
    },
    mounted () {
      this.setText(this.value)
    },
    watch: {
      value: function (newValue) {
        this.setText(newValue)
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      })
    },
    methods: {
      calcHeightEditor () {
        return this.calcDialogScroll(48 + 52, 48 + 52)
      },
      cancel () {
        this.$emit('close')
      },
      save () {
        let text = this.editor.getContent()
        this.$emit('change', text)
        this.cancel()
      },
      setText (value) {
        this.text = value
      }
    }
  }

</script>




// WEBPACK FOOTER //
// EditorForm.vue?22fdfdfe